import EventBus from "@plugins/common/service/eventbus";

const resourceTaggingEventBus = new EventBus();

export default resourceTaggingEventBus;
